import React from 'react';
import ReactDOM from 'react-dom';
import './Modal.css';

/* 
 * If you're here, you are probably looking for how to build a new modal. You 
 * should probably look at an existing component that uses this class, like
 * MasterPool. This merely creates the element; styling and other fancy
 * features are the responsibility of the calling class.
 */

const modalRoot = document.getElementById('modal-root');

class Modal extends React.Component {
	constructor(props) {
		super(props);
		// Create a div that we'll render the modal into. Because each
		// Modal component has its own element, we can render multiple
		// modal components into the modal container.
		this.el = document.createElement('div');
	}

	componentDidMount() {
		// Append the element into the DOM on mount. We'll render
		// into the modal container element (see the HTML tab).
		modalRoot.appendChild(this.el);
	}

	componentWillUnmount() {
		// Remove the element from the DOM when we unmount
		modalRoot.removeChild(this.el);
	}
	
	render() {
		// Use a portal to render the children into the element
		return ReactDOM.createPortal(this.props.children, this.el);
	}
}
export default Modal;